import React, { useEffect } from 'react';
import Menu from 'components/Menu';
import { useLocation } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import navbarItems from 'helpers/navigationOptionsHelper';
import { setDisplayMenu } from '../store/actions/layout';
import { useTheme } from 'styled-components';

const MenuContainer = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const displayMenu = useSelector((state) => state.displayMenu);
  const displayNavBar = useSelector((state) => state.displayNavBar);
  const subscription = useSelector((state) => state.subscription);
  const account = useSelector((state) => state.account);
  const location = useLocation();

  const hideMenu = () => dispatch(setDisplayMenu(false));

  const items = navbarItems(subscription, account, location);

  useEffect(() => {
    const hideMenuOnDesktop = () =>
      displayMenu && window.innerWidth > theme.breakpoints.md ? hideMenu() : null;

    window.addEventListener("resize", hideMenuOnDesktop);
    return () => window.removeEventListener("resize", hideMenuOnDesktop);
  });

  return (
    (displayNavBar && displayMenu)
      ? (<Menu
        onClose={() => hideMenu()}
        items={items}
      />)
      : null
  );
};

MenuContainer.displayName = 'MenuContainer';

export default MenuContainer;
